// ANGULAR DEPENDENCY
import { NgModule } from '@angular/core';

// NGRX
import { EffectsModule } from '@ngrx/effects';
import { ActionReducer, MetaReducer, StoreModule } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';

// STORE REDUCER AND EFFECTS
import { MasterBusinessEffects } from './store/effects';
import * as fromMasterBusiness from './store/reducer';

// SERVICES
import { MasterBusinessStoreService } from './master-business-store.service';
import { MasterBusinessService } from './services/master-business.service';

/**
 * Local storage sync function for sync store state keys with local storage
 */
export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({ keys: [], rehydrate: true })(reducer);
}

// add localstorage function in meta reducers
const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer];

/**
 * This module is for configure master business ngrx related stuff.
 *
 * @author Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>
 * Notes:-
 * Date: 27-04-2020 master business store module created
 */
@NgModule({
  imports: [
    StoreModule.forFeature('masterbusiness', fromMasterBusiness.reducer, { metaReducers }),
    EffectsModule.forFeature([MasterBusinessEffects]),
  ],
  declarations: [],
  providers: [
    MasterBusinessService,
    MasterBusinessStoreService,
  ],
})
export class MasterBusinessStoreModule { }
